import "components/order/style/OrderDetail.css";

const OrderPayType = ({ isNotMeet }) => {
  return (
    <div className="payment_frame">
      <div className="wrap_frame">
        <div className="payment">
          <span className="payment-title">결제 수단</span>
          <ul className="payment-list">
            <input
              type="radio"
              id="payment-credit"
              name="payment-type"
              value="11"
              defaultChecked
            />
            <label htmlFor="payment-credit"></label>
            <input
              type="radio"
              id="payment-phone"
              name="payment-type"
              value="31"
            />
            <label htmlFor="payment-phone"></label>
            {/* 비활성화 */}
            <input 
              type="radio"
              id="payment-meet"
              name="payment-type"
              value="2"
              disabled={isNotMeet}
            />
            <label htmlFor="payment-meet" style={{display:(!isNotMeet?"":"none")}}></label>
            <input
              type="radio"
              id="payment-cash"
              name="payment-type"
              value="1"
              disabled={isNotMeet}
            />
            <label htmlFor="payment-cash" style={{display:(!isNotMeet?"":"none")}}></label>
            {/* 비활성화  끝*/}
          </ul>
          <p className="Precautions">
            {isNotMeet && (
              <>
                <span className="font-color">만나서 결제</span>를{" "}
                <span className="font-color">지원하지 않는 상점이 포함</span>
                되어 있습니다.
                {/* <span className="font-weight"> 결제 수단을 다시 선택</span>
                해주세요! */}
              </>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default OrderPayType;
